import { ActionMap } from 'action-typed';

import type { AlgoliaAnalyticsState } from './types';

export enum AlgoliaEvents {
    ANALYTICS_CONSENT_CHANGED = 'Algolia.Analytics.ConsentChanged',
    ANALYTICS_INITIALISE = 'Algolia.Analytics.Initialise',
    ANALYTICS_SET_ANONYMOUS_USER_TOKEN = 'Algolia.Analytics.SetAnonymousUserToken',
    ANALYTICS_SET_AUTHENTICATED_USER = 'Algolia.Analytics.SetAuthenticatedUser',
    ANALYTICS_UNSET_AUTHENTICATED_USER = 'Algolia.Analytics.UnsetAuthenticatedUser',
}

export type Messages = {
    [AlgoliaEvents.ANALYTICS_CONSENT_CHANGED]: Pick<AlgoliaAnalyticsState, 'anoymousUserToken'>;
    [AlgoliaEvents.ANALYTICS_INITIALISE]: Pick<AlgoliaAnalyticsState, 'anoymousUserToken'>;
    [AlgoliaEvents.ANALYTICS_SET_ANONYMOUS_USER_TOKEN]: Pick<AlgoliaAnalyticsState, 'anoymousUserToken'>;
    [AlgoliaEvents.ANALYTICS_SET_AUTHENTICATED_USER]: Pick<AlgoliaAnalyticsState, 'authenticatedUserToken'>;
    [AlgoliaEvents.ANALYTICS_UNSET_AUTHENTICATED_USER]: void;
};

export type TypeMap = ActionMap<Messages>;
export type AlgoliaActions = TypeMap[keyof TypeMap];
